module.exports = __webpack_public_path__ + "static/media/link_icon_white.c2a8c8e5.svg";